import { useEffect, useState } from "react";

export function useCyclingOrder<T>(
    items: T[],
    updatedAt: number,
    isReversed = false
) {
    const [lastUpdate, setLastUpdate] = useState(updatedAt);
    const [orderedItems, setOrderedItems] = useState(items);

    useEffect(() => {
        // zero or one items can't be cycled through
        if (orderedItems.length < 2) {
            return;
        } else if (updatedAt > lastUpdate) {
            if (isReversed) {
                const lastItem = orderedItems.slice(-1);
                const remainingItems = orderedItems.slice(0, -1);
                setOrderedItems([...lastItem, ...remainingItems]);
            } else {
                const firstItem = orderedItems.slice(0, 1);
                const remainingItems = orderedItems.slice(
                    1,
                    orderedItems.length
                );
                setOrderedItems([...remainingItems, ...firstItem]);
            }
            setLastUpdate(updatedAt);
        }
    }, [isReversed, lastUpdate, orderedItems, updatedAt]);

    return orderedItems;
}
